// src/pages/Payment/StripeCancel.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StripeCancelPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // 可选：你可以在这里做埋点
    // analytics.track("stripe_payment_cancelled");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center max-w-md p-8 bg-white dark:bg-gray-800 rounded-2xl shadow">

        {/* ICON */}
        <div className="text-5xl mb-4">⚠️</div>

        {/* TITLE */}
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Payment Cancelled
        </h2>

        {/* MESSAGE */}
        <p className="text-gray-600 mb-6">
          You didn’t complete the payment. No charges were made.
        </p>

        {/* ACTIONS */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-black text-white rounded-lg hover:opacity-90"
          >
            Go Back
          </button>

          <button
            onClick={() => navigate("/courses")}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            Browse Courses
          </button>
        </div>

        {/* OPTIONAL NOTE */}
        <p className="text-xs text-gray-400 mt-6">
          You can restart checkout anytime from the course page.
        </p>
      </div>
    </div>
  );
}